export const LANDING_PAGE = '/enterprise'